
export default {
  name: 'MonksPrimaryButton',

  props: {
    cta: {
      type: String,
      required: true,
    },
    classes: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '_self',
    },
    isDarkSection: {
      type: Boolean,
      default: false,
    },
    isLatam: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    componentTag() {
      return this.href ? 'a' : 'button'
    },

    buttonClasses() {
      return [
        'primary-button',
        {
          'latam-padding': this.isLatam,
          'white-hover': this.isDarkSection,
        },
        this.classes,
      ]
    },
  },

  methods: {
    handleClick() {
      this.$emit('click')
    },

    handleAuxClick(event) {
      if (event.button === 1) {
        this.$emit('click')
      }
    },
  },
}
